<template>
  <div :class="$style.productlist">
    <div :class="$style['home-subproduct-story']">
      <v-col cols="6" v-for="(item, index) in list" :key="index">
        <div :class="$style['home-subproduct-story-sub']" style="position: relative">
          <div role="button" v-ripple @click="plusItem(item)"
               style="width: 60%;text-align: left; "
               :style="purchaseAble && item.product_count == 0 && item.product_quantity > 0 ? 'opacity : unset' : 'opacity: 0'">
            <v-icon style="font-size: 15px">add</v-icon>
          </div>
          <div :class="$style['addproductB']" v-if="purchaseAble && item.product_count > 0 && shop_id == basket_shop_id">
            <ul style="padding-left: 0">
              <li role="button" v-ripple @click="plusItem(item)">
                <v-icon style="transform: scale(0.7)">control_point</v-icon>
              </li>
              <li style="color: white; padding: 0 10px 0 10px">
                {{ item.product_count }}
              </li>
              <li role="button" v-ripple @click="minusItem(item)">
                <v-icon style="transform: scale(0.7)">remove_circle_outline
                </v-icon>
              </li>
            </ul>
            <ul style="display: flex;justify-content: center; align-items: center; padding-left: 0">
              <li style="font-size: 12px; color: white">
                {{
                  item.product_quantity == 0 ? '' :
                      'موجودی: ' +
                      (item.product_quantity > 3 ? '3+' : item.product_quantity)
                }}
              </li>
            </ul>
          </div>
          <div :class="$style['itemStory']" role="button" v-ripple @click="redirectProduct(item.product_id)">
            <img :src="item.product_icon" :alt="item.product_title"/>
            <span v-if="item.product_discount != null && item.product_discount > 0 && item.product_count == 0"
                  :class="$style['img-discount_product']">{{ item.product_discount + '%'}}</span>
          </div>
          <div :class="$style['titleName']">
            <span class="multi-line">{{ item.product_title }}</span>
            <span v-if="shop_id != null"
                  :style="item.product_quantity > 0 ? 'color : #7dc353' : 'color : red'">
                                {{
                item.product_quantity > 0 ? oracle.format(item.product_sell_price)
                    + ' تومان  ' : 'ناموجود  '
              }}</span>
          </div>
        </div>
      </v-col>
    </div>
    <div style="height: 60px !important;"></div>
  </div>
</template>

<script>
import oracle from "@/utils/oracle";

export default {
  name: "OrderList",
  data() {
    return {
      oracle: oracle,
      loading: false,
      basket_shop_id: null,
    }
  },
  props: {
    list: [],
    shop_id: null,
    purchaseAble: null,
  }, methods: {
    plusItem(item) {
      if (!this.purchaseAble) return;
      if (item.product_count >= item.product_quantity) {
        return;
      }
      if (oracle.getShop() != null && oracle.getShop() != this.shop_id) {
        oracle.showMessage('در صورت تغییر فروشگاه، لیست محصولات انتخابی شما در سبد خرید پاک خواهد شد. ادامه میدهید؟'
            , 'ادامه میدهم', () => {
              oracle.clearBasket()
              oracle.setShop(null)
              this.plusItem(item)
              this.checkList(this.list)
            })
        return;
      } else {
        oracle.setShop(this.shop_id);
      }
      item.product_count = item.product_count + 1
      oracle.addToBasket(item.product_id);
      this.$root.$emit("numBasket");
      this.basket_shop_id = this.shop_id
    },
    minusItem(item) {
      if (!this.purchaseAble) return;
      if (item.product_count == 0) {
        return;
      }
      item.product_count--;
      oracle.removeFromBasket(item.product_id);
      this.$root.$emit("numBasket");
      this.basket_shop_id = this.shop_id
    },
    redirectProduct(id) {
      this.$router.push({name: 'ProductInfo', query: {id: id}})
    },
    checkList(newVal) {
      let basket = oracle.getBasket();
      if (basket == null || basket.length == 0) return
      if (newVal != null) {
        newVal.forEach(item => {
          let sum = 0
          basket.forEach(id => {
            if (item.product_id == id) {
              sum++;
            }
          })
          if (item.product_quantity != null && sum > item.product_quantity) {
            sum = item.product_quantity
          }
          item.product_count = sum
        })
      }
    }
  }, watch: {
    list: function (newVal, oldVal) {
      this.checkList(newVal)
    }
  }, mounted() {
    this.basket_shop_id = oracle.getShop()
  }
}
</script>

<style module>
.productlist .home-subproduct-story {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  overflow: auto;
}

.productlist .home-subproduct-story-sub {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
}

.productlist .home-subproduct-story-sub i {
  color: #7dc353;
  /*font-size: 15px;*/
}

.productlist .addproductB ul {
  display: flex;
  background-color: #7dc353;
  margin-bottom: 3px !important;
}

.productlist .addproductB ul:nth-child(1) {
  border-radius: 20px 0 20px 20px;
}

.productlist .addproductB ul:nth-child(2) {
  border-radius: 20px
}

.productlist .addproductB ul li {
  padding: 0 5px;
}

.productlist .addproductB i {
  color: white;
}

.productlist .itemStory {
  width: 70px;
  background: transparent;
  height: 70px;
  position: relative;
  /*background: #ffdb02;*/
  /*border: 2px solid #ffdb02;*/
  overflow: hidden;
}

.productlist .itemStory img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 100%;
}

.productlist .titleName {
  text-align: center;
  font-size: 13px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}

.productlist .home-subproduct-head {
  display: flex;
  justify-content: space-between;
  background-color: #dbdada;
  height: 40px
}

.productlist .home-subproduct-head span {
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #dbdada;
  height: 40px;
  align-items: center;
  margin-right: 15px
}

.productlist .home-subproduct-search {
  display: flex;
  justify-content: space-between;
  height: 40px
}

.productlist {
  height: 100%;
  overflow: scroll;
}

.productlist a {
  text-decoration: none;
}

.productlist .home-subproduct-title {
  display: flex;
  justify-content: right;
  color: white;
  background-color: rgb(126, 195, 82);
  height: 40px;
  align-items: center;
}

.productlist .home-subproduct-btn button {
  margin-bottom: 17px;
  position: fixed;
  bottom: 50px;
  left: 25px;
  border-radius: 50%;
  background-color: #7ec352 !important;
  color: white !important;
  display: block !important;
  height: 54px !important;
  min-width: 54px !important;
}

.productlist .home-subproduct-btn p {
  background-color: #cc7540;
  position: fixed;
  bottom: 90px;
  left: 60px;
  border-radius: 50%;
  width: 25px;
  text-align: center;
  color: white;
  height: 25px;
  font-size: 12px;
  line-height: 25px;
}

.productlist .img-discount_product {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  background: #7fc452;
  width: 25px;
  text-align: center;
  height: 25px;
  min-width: 25px;
  min-height: 25px;
  color: white;
  font-weight: bold;
  border-radius: 100%;
  padding-top: 4px;
}
</style>